/** Deduplicate concurrent POS bill bootstrap (e.g. React StrictMode remount). */

const inFlight = new Map();

/**
 * @template T
 * @param {string} key
 * @param {() => Promise<T>} fn
 * @returns {Promise<T>}
 */
export function runPosBootstrap(key, fn) {
  if (!key) return fn();

  const existing = inFlight.get(key);
  if (existing) return existing;

  const promise = fn().finally(() => {
    if (inFlight.get(key) === promise) {
      inFlight.delete(key);
    }
  });

  inFlight.set(key, promise);
  return promise;
}
